import { Inject, Injectable } from '@angular/core';
import { DataRequirements, DataRequirementsInjectionToken } from '../data.requirements';

@Injectable({
  providedIn: 'root'
})
export class resubscribePlanUseCase {
  constructor(
    @Inject(DataRequirementsInjectionToken) private data: DataRequirements
  ) {}

  run(uid, sid) {
    return this.data.resubscribePlan(uid, sid);
  }
}
